import React, { memo, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import './menu-category-style.css';
import IconMenu from '../../icons/IconMenu/IconMenu';
import { Context } from '../../../context/global-data-provider';
import Search from '../../components/Search/Search';
import SearchProvider from '../../../context/search-context';
import InquiryMenuItems from '../../../features/customer-inquiry/components/InquiryMenuItems';
import Svg from '../../components/icons/svg';

const MenuApp = () => {
  const { options } = useContext(Context);
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen(!open);
  }

  function closeMenu() {
    setOpen(false);
  }

  return (
    <SearchProvider>
      <div className="menu-app p-relative">
        <button
          className={'btn br-c-p bc-b-c d-flex align-items-center justify-content-center toggle-button'}
          type="button"
          onClick={toggleOpen}
        >
          <IconMenu height={20} width={20} fill={'#262626'} />
        </button>
        {open && (
          <div className="p-relative">
            <div className="menu-nav-closer" onClick={closeMenu} />
            <div className="menu-nav bg--gray-1">
              <ul>
                <Search mode="item" className="item c-p" onClick={closeMenu} />
                <li className="item" onClick={closeMenu}>
                  <a href={`tel:${options.phone}`} className="d-flex" target="_blank" rel="noopener noreferrer">
                    تماس با تلفن گویا
                  </a>
                </li>
                <li className="item" onClick={closeMenu}>
                  <a
                    href={`https://instagram.com/_u/${options.instagram}`}
                    className="d-flex"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    صفحه اینستاگرام
                  </a>
                </li>
                {(options.rubika_link || options.whatsapp_link) && (
                  <li className="item" onClick={closeMenu}>
                    <a
                      href={options.rubika_link || options.whatsapp_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center"
                    >
                      <Svg name="rubika" width={18} height={18} label="Rubika" />
                      <span className="mr-8p">تماس در روبیکا</span>
                    </a>
                  </li>
                )}
                <li className="item" onClick={closeMenu}>
                  <Link to={'/guide'} className="d-flex f-grow-1">
                    راهنمای سایت
                  </Link>
                </li>
                <InquiryMenuItems onNavigate={closeMenu} />
              </ul>
            </div>
          </div>
        )}
      </div>
    </SearchProvider>
  );
};

export default memo(MenuApp);
